import {
  API_ERROR,
  GET_LOCATIONS,
  LOCATION_LIST_SUCCESSFUL,
  GET_SUB_LOCATIONS,
  SUB_LOCATION_LIST_SUCCESSFUL,
  GET_DEPARTMENT,
  DEPARTMENT_LIST_SUCCESSFUL,
  GET_USERS,
  USERS_LIST_SUCCESS,
  USER_ROW_DATA,
  USER_ROW_DATA_SUCCESS,
  GROUPS_LIST,
  GROUPS_LIST_SUCCESS,
  DEPT_SELECT_FILED,
  REMOVE_DEPT_SELECT_FILED,
  SELECT_CHANGE_DEPT_VALUE,
  GET_HOD_CHECKED,
  LOC_SELECT_FILED,
  REMOVE_LOC_SELECT_FILED,
  SELECT_CHANGE_LOC_VALUE,
  MULTI_SELECT_SUBLOC_CHANGEVALUE,
  INPUT_CHANGEVALUE,
  SELECT_CHANGEVALUE,
  MULTI_SELECT_CHANGEVALUE,
  MODEL_OPEN,
  MODEL_CLOSE,
  USER_ADD,
  USER_ADD_SUCCESSFUL,
  //---------------
  // GET_LOCATIONS,
  // LOCATION_LIST_SUCCESSFUL,
  USER_EDIT,
  USER_EDIT_SUCCESSFUL,
  GROUP_ADD,
  GROUP_ADD_SUCCESSFUL,
  SET_PARAMS,
  SET_PROFILE_PARAMS,
  UPDATE_GROUPS_LIST,
  SET_PROFILE_PAGINATION_PARAMS,
  PAGINATION_GROUPS_LIST_SUCCESS,
} from "./actionTypes";

const initialState = {
  locationslist: [],
  sublocationslist: [],
  deparmentslist: [],
  Userslist: [],
  UserRowData: {},
  groupsList: [],
  paginationGroupList :[],

  inputDeptList: [
    { id: 0, departmentLabel: "", department_id: "", Deptcheck: false },
  ],
  inputLocList: [
    {
      id: 0,
      locationLabel: "",
      location_id: "",
      subLocations: [],
    },
  ],
  hodIds: [],
  params: {
    no_of_pages: 0,
    page_size: 10,
    page: 1,
    search: "",
    currentSort: "code",
    sortOrder: "-",
  },
  profileParams : {
    no_of_pages: 0,
    page_size: 10,
    page: 1,
    search: "",
    currentSort: "code",
    sortOrder: "-",
  },
  profilePaginationParams : {
    no_of_pages: 0,
    page_size: 10,
    page: 1,
    search: "",
    currentSort: "code",
    sortOrder: "-",
  },
  //--------------------
  error: "Sorry! No Data Found.",
  message: null,
  loading: false,
  rowlist: [],

  model: false,
  error_msg: null,
  rowdata: {},
  groupdata: {},
};

const users = (state = initialState, action) => {
  switch (action.type) {
    case GET_LOCATIONS:
      state = {
        ...state,
        loading: true,
        // inputLocList: locList1,
      };

      break;
    case LOCATION_LIST_SUCCESSFUL:
      state = {
        ...state,
        locationslist: action.payload.response,
        loading: false,
      };

      break;
    case GET_SUB_LOCATIONS:
     
      // state.sublocationslist[action.payload.id] = [];
      state = {
        ...state,
        loading: true,
        // locId: action.payload.locId,
      };
      break;
    case SUB_LOCATION_LIST_SUCCESSFUL:
      state = {
        ...state,
        sublocationslist: action.payload.response,
        loading: false,
      };
      // state.sublocationslist[action.payload.locId] = action.payload.response;
      break;
    case GET_DEPARTMENT:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DEPARTMENT_LIST_SUCCESSFUL:
      state = {
        ...state,
        deparmentslist: action.payload.response,
        loading: false,
      };
      break;
    case GET_USERS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case USERS_LIST_SUCCESS:
      var noofpages = Math.ceil(action.payload.count / state.params.page_size);
      state = {
        ...state,
        Userslist: action.payload.results,
        loading: false,
        params: {
          ...state.params,
          no_of_pages: noofpages,
        },
      };
      break;
    case USER_ROW_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case USER_ROW_DATA_SUCCESS:

      var deptList = [];
      deptList = action.payload.departments.map((dept, i) => {
        return {
          id: i,
          departmentLabel: dept.name,
          department_id: dept.id,
          Deptcheck:
            action.payload.hod_to.indexOf(dept.id) !== -1 ? true : false,
        };
      });
      var groups = action.payload.groups.map((group) => {
        return {
          label: group.name,
          value: group.id,
        };
      });
      var locList1 = [];
      locList1 = action.payload.locations.map((loc, i) => {
        return {
          id: i,
          locationLabel: loc.name,
          location_id: loc.id,
          subLocations: action.payload.sublocations
            .filter((subloc) => subloc.location === loc.id)
            .map((subloc) => {
              return {
                label: subloc.name,
                value: subloc.id,
              };
            }),
        };
      });

      // var subLocations = action.payload.sublocations.map((loc) => {
      //   return {
      //     label: loc.name,
      //     value: loc.id,
      //   };
      // });

      state = {
        ...state,
        UserRowData: { ...action.payload, groups: groups },
        inputDeptList: deptList,
        hodIds: action.payload.hod_to,
        model: true,
        inputLocList: locList1,
      };
      break;
    case GROUPS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
      case GROUPS_LIST_SUCCESS:
        var noofpages = Math.ceil(action.payload.count / state.params.page_size);
    
        // Merge new items with existing ones, ensuring uniqueness
        const newGroups = [...state.groupsList, ...action.payload.results].reduce(
            (acc, item) => {
                if (!acc.some((g) => g.id === item.id)) {
                    acc.push(item);
                }
                return acc;
            },
            []
        );
    
        state = {
            ...state,
            groupsList: newGroups, // Append new items, ensuring uniqueness
            loading: false,
            profileParams: {
                ...state.profileParams,
                no_of_pages: noofpages,
                total_count: action.payload.count, // Store total count
            },
        };
        break;
        case PAGINATION_GROUPS_LIST_SUCCESS:
          var noofpages = Math.ceil(action.payload.count / state.params.page_size);
      
          // Merge new items with existing ones, ensuring uniqueness
          const updatedGroupsList = [...action.payload.results].reduce(
            (acc, item) => {
                if (!acc.some((g) => g.id === item.id)) {
                    acc.push(item);
                }
                return acc;
            },
            []
        );
        state = {
          ...state,
          paginationGroupList: updatedGroupsList, // Update the list conditionally
          loading: false,
          profilePaginationParams: {
              ...state.profilePaginationParams,
              no_of_pages: noofpages,
              total_count: action.payload.count, // Store total count
          },
      };
          break;
    case UPDATE_GROUPS_LIST:
      state = {
        ...state,
        groupsList: [...state.groupsList, ...action.payload], // Append new data
      };
      break;
    case DEPT_SELECT_FILED:
      state = {
        ...state,
        inputDeptList: [
          ...state.inputDeptList,
          {
            id: action.payload.id == null ? 0 : action.payload.id + 1,
            departmentLabel: "",
            department_id: "",
            Deptcheck: false,
          },
        ],

        loading: false,
      };
      break;
    case REMOVE_DEPT_SELECT_FILED:
      var DeptList = [];
      DeptList = state.inputDeptList.filter((dept) => {
        return dept.id !== action.payload.id;
      });
      state.inputDeptList = DeptList;

      break;
    case SELECT_CHANGE_DEPT_VALUE:
      var list = [];
      list = [...state.inputDeptList];
      list[action.payload.i][action.payload.key] = action.payload.label;
      list[action.payload.i][action.payload.key2] = action.payload.value;
      state.inputDeptList = list;
      var deparmentslist = state.deparmentslist.filter((dept) => {
        return dept.id !== action.payload.value;
      });
      state.deparmentslist = deparmentslist;

      // var hodIds = state.hodIds.filter((hod) => {
      //   return hod !== state.inputDeptList[action.payload.i].department_id;
      // });

      // state.inputDeptList[action.payload.i].Deptcheck = false;
      // state = {
      //   ...state,
      //   hodIds: hodIds,
      // };

      break;

    case GET_HOD_CHECKED:
      if (action.payload.checked === true) {
        state.inputDeptList[action.payload.index].Deptcheck = true;
        state = {
          ...state,
          hodIds: [
            ...state.hodIds,
            state.inputDeptList[action.payload.index].department_id,
          ],
        };
      } else {
        var hod_ids = state.hodIds.filter((hod) => {
          return (
            hod !== state.inputDeptList[action.payload.index].department_id
          );
        });

        state.inputDeptList[action.payload.index].Deptcheck = false;
        state = {
          ...state,
          hodIds: hod_ids,
        };
      }

      break;
    case LOC_SELECT_FILED:
      state = {
        ...state,
        inputLocList: [
          ...state.inputLocList,
          {
            id: action.payload.id == null ? 0 : action.payload.id + 1,
            locationLabel: "",
            location_id: "",
            SublocationLabel: "",
            Sublocation_id: "",
          },
        ],
        loading: false,
      };
      break;
    case REMOVE_LOC_SELECT_FILED:
      var locList = [];
      locList = state.inputLocList.filter((loc) => {
        return loc.id !== action.payload.id;
      });
      state.inputLocList = locList;

      break;
    case SELECT_CHANGE_LOC_VALUE:
      var loclist = [];
      locList = state.inputLocList.map((loc, i) => {
        if (loc.id === action.payload.value) {
          loc.sublocations = [];
        }

        return loc;
      });

      loclist = [...state.inputLocList];
      loclist[action.payload.i][action.payload.key] = action.payload.label;
      loclist[action.payload.i][action.payload.key2] = action.payload.value;
      state.inputLocList = loclist;
      break;
    case MULTI_SELECT_SUBLOC_CHANGEVALUE:
      var Subloclist = [];
      Subloclist = [...state.inputLocList];
      Subloclist[action.payload.i]["subLocations"] = action.payload.multiValues;

      state.inputLocList = Subloclist;

      break;
    case INPUT_CHANGEVALUE:
      state = {
        ...state,
        UserRowData: {
          ...state.UserRowData,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case SELECT_CHANGEVALUE:
      state = {
        ...state,
        UserRowData: {
          ...state.UserRowData,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case MULTI_SELECT_CHANGEVALUE:
      state = {
        ...state,
        UserRowData: {
          ...state.UserRowData,
          [action.payload.label]: action.payload.multiValues,
        },
      };
      break;
    case MODEL_OPEN:
      state = {
        ...state,
        inputDeptList: [
          { id: 0, departmentLabel: "", department_id: "", Deptcheck: false },
        ],
        inputLocList: [
          {
            id: 0,
            locationLabel: "",
            location_id: "",
            subLocations: [],
          },
        ],
        UserRowData: {},
        model: true,
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,

        model: false,
      };
      break;
    case USER_ADD:
      state = {
        ...state,
        loading: false,
        model: true,
      };
      break;
    case USER_ADD_SUCCESSFUL:
      state = {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
      };
      break;
    case USER_EDIT:
      state = {
        ...state,
        loading: false,
        model: true,
      };
      break;
    case USER_EDIT_SUCCESSFUL:
      state = {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
      };
      break;
    //-------------

    // case GET_LOCATIONS:
    //   state = {
    //     ...state,
    //     loading: true,
    //   };
    //   break;
    // case LOCATION_LIST_SUCCESSFUL:
    //   state = {
    //     ...state,
    //     locationslist: action.payload.response.results,
    //     loading: false,
    //   };
    //   break;

    case GROUP_ADD:
      state = {
        ...state,
        loading: false,
      };
      break;
    case GROUP_ADD_SUCCESSFUL:
      state = {
        ...state,
        message: action.payload,
        loading: false,
      };
      break;
    case SET_PARAMS:
      state = {
        ...state,
        params: action.payload,
      };
      break;
    case SET_PROFILE_PARAMS:
      state = {
        ...state,
        profileParams: action.payload,
      };
      break;
    case SET_PROFILE_PAGINATION_PARAMS:
      state = {
        ...state,
        profilePaginationParams: action.payload,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default users;
